module.exports = __webpack_public_path__ + "img/n4.92e9bb1c.jpg";